module.exports = __webpack_public_path__ + "img/a0ed2e517f9001bfcce438eacb7d7388.png";